import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { Pagination } from 'components/molecules/Pagination/Pagination';
import { FC } from 'react';
import { Notification } from 'types/notification';
import { NotificationListHeader } from './NotificationListHeader';
import { NotificationListItem } from './NotificationListItem';
import { NotificationListSkeleton } from './NotificationListSkeleton';

type Props = {
  loading: boolean;
  currentPage: number;
  lastPage: number;
  notifications: Notification[];
  handlePageChange: (page: number) => void;
  handleClickNotification: (notification: Notification) => void;
};

export const NotificationListView: FC<Props> = ({
  loading,
  currentPage,
  lastPage,
  notifications,
  handlePageChange,
  handleClickNotification,
}) => {
  if (loading) {
    return <NotificationListSkeleton />;
  }

  return (
    <>
      {/* お知らせ一覧のヘッダ */}
      <Box m="20px 0 0 0">
        <NotificationListHeader />
      </Box>
      {/* お知らせ一覧 */}
      <ListView>
        {notifications.map((item) => (
          <ListItem key={item.id} listStyleType="none">
            <NotificationListItem
              title={item.title}
              message={item.message}
              levelName={item.levelName}
              displayStatus={item.displayStatus}
              startsAt={item.startsAt}
              endsAt={item.endsAt}
              handleClickNotification={() => handleClickNotification(item)}
            />
          </ListItem>
        ))}
      </ListView>
      {/* ページネーション */}
      <Box m="20px 0 0 0">
        <Pagination
          currentPage={currentPage}
          pageCount={lastPage}
          handlePageChange={handlePageChange}
        />
      </Box>
    </>
  );
};
